module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("LIST OF PLATES")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("1.")]), _vm._v(" The Rev. Dr Richard Price FRS.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("2.")]), _vm._v(" Charles Watson Wentworth, 2nd Marquis of Rockingham.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("3.")]), _vm._v(" The Rev Christopher Wyvill.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("4.")]), _vm._v(" John Cartwright.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("5.")]), _vm._v(" The Rev. Dr Joseph Priestley.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("6.")]), _vm._v(" Thomas Paine.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("7.")]), _vm._v(" Edmund Burke.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("8.")]), _vm._v(" William Pitt.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("9.")]), _vm._v(" Charles James Fox.")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno1"
  }, [_vm._v("10.")]), _vm._v(" William Wentworth-Fitzwilliam, 4th Earl Fitzwilliam.")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno1"
  }, [_vm._v("11.")]), _vm._v(" Henry Redhead Yorke.")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno1"
  }, [_vm._v("12.")]), _vm._v(" The Rev. Thomas Johnstone.")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno1"
  }, [_vm._v("13.")]), _vm._v(" Edward Marcus Despard.")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno1"
  }, [_vm._v("14.")]), _vm._v(" Thomas Walker.")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno1"
  }, [_vm._v("15.")]), _vm._v(" The Rev. William Robert Hay.")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Plates01#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "lno1"
  }, [_vm._v("16.")]), _vm._v(" Robert Athorpe.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a23fa00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Plates.vue
// module id = 69
// module chunks = 0